// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__31Tst","actions":"GroupTable_actions__3eCcy","deleteModalFooter":"GroupTable_deleteModalFooter__1DcLf"};